<ngf-dialog-title mat-dialog-title>
  New Version
</ngf-dialog-title>

<mat-dialog-content>
  <span class="modal-message">
    A new version of this application is available. Please reload this page in your browser and try again.
  </span>
</mat-dialog-content>

<mat-dialog-actions>
  <button ngfButton="primary" (click)="reload()">Reload</button>
</mat-dialog-actions>
